import React from "react";
import Icon from "src/icons";

const PencilSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="12" viewBox="0 0 11 12">
    <path
      fill="#FFF"
      fillRule="nonzero"
      d="M.456 9.2l6.453-6.453 2.187 2.187-6.453 6.454H.456V9.2zm10.336-5.96L9.725 4.304 7.538 2.118l1.066-1.066a.556.556 0 0 1 .41-.164c.164 0 .301.054.41.164l1.368 1.367c.109.11.164.246.164.41 0 .164-.055.3-.164.41z"
      opacity=".5"
    />
  </svg>
);
export const PencilIcon = (props) => <Icon component={PencilSvg} {...props} />;
